<template>
  <div id="contenedor-contrato-minutas-acuerdos-pendientes">
    <template
      v-for="(grupo, nombreGrupo) in listadoAgrupado">
      <template>
        <div
          v-if="grupo.length > 0"
          :key="nombreGrupo"
          class="mb-4">
          <div>
            <!-- <v-badge inline :color="getColorPorAgrupador(nombreGrupo)" dot></v-badge> -->
            <span class="subtitle-2 font-weight-bold">
              {{ tituloAgrupador(nombreGrupo) }}
            </span>
            <v-icon small :color="getColorPorAgrupador(nombreGrupo)">
            {{ getIconoPorAgrupador(nombreGrupo) }}
            </v-icon>
          </div>
          <template
            v-for="(acuerdo, index) in grupo">
            <template>
              <v-hover
                v-slot="{ hover }"
                open-delay="100"
                :key="`acuerdo-${nombreGrupo}-${index}`">
                <v-row
                  justify="space-between"
                  no-gutters
                  class="pa-1 mb-1 rounded-lg align-center"
                  :class="{ 'grey lighten-4': hover }">
                  <v-col cols="10">
                    <div>
                      <span class="text-caption font-weight-ligth">
                      <cortar-texto
                      :texto="acuerdo.nombre!='' && acuerdo.nombre!=null
                      ? acuerdo.nombre : ''"
                      >
                      </cortar-texto>
                      </span>
                      <v-chip x-small :color="nombreGrupo === 'ayer' ? 'warning' : 'white'">
                        <v-icon small left>
                          {{ getIconoPorAgrupador(nombreGrupo) }}
                        </v-icon>
                        {{ $moment(acuerdo.fecha).format('DD/MM/YYYY') }}
                      </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs}">
                      <div v-bind="attrs" v-on="on">
                          <CheckVencidos
                          :acuerdo="acuerdo"  />
                      </div>
                      </template>
                      <span>
                        <div v-if="acuerdo.fechaHoraCumplimiento">
                          Desmarcar acuerdo como cumplido</div>
                        <div v-if="!acuerdo.fechaHoraCumplimiento">
                          Marcar acuerdo como cumplido
                        </div>
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-hover>
            </template>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import CheckVencidos from '@/components/administracion/minutas/acuerdos/checkVencidos.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContratoMinutasListadoAcuerdos',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  components: {
    CheckVencidos,
    CortarTexto,
  },
  methods: {
    tituloAgrupador(nombreGrupo) {
      switch (nombreGrupo) {
        case 'vencidos':
          return 'Vencido(s)';
        case 'hoy':
          return 'Hoy';
        case 'manana':
          return 'Mañana';
        case 'estaSemana':
          return 'Esta semana';
        case 'proximaSemana':
          return 'Semana próxima';
        case 'esteAno':
          return 'Este año';
        default:
          return 'Otros';
      }
    },
    getIconoPorAgrupador(nombreGrupo) {
      switch (nombreGrupo) {
        case 'vencidos':
          return 'mdi-progress-close';
        case 'hoy':
          return 'mdi-clock-time-eleven-outline';
        case 'manana':
          return 'mdi-clock-time-nine-outline';
        case 'estaSemana':
          return 'mdi-clock-time-seven-outline';
        case 'proximaSemana':
          return 'mdi-clock-time-one-outline';
        case 'esteAno':
          return 'mdi-calendar-month';
        default:
          return 'mdi-calendar';
      }
    },
    getColorPorAgrupador(nombreGrupo) {
      switch (nombreGrupo) {
        case 'vencidos':
          return 'red darken-1';
        case 'manana':
        case 'hoy':
          return 'error';
        default:
          return 'success';
      }
    },
    esVencido(fecha) {
      const ahora = new Date();
      return fecha < ahora;
    },
    esHoy(fecha) {
      const ahora = new Date();
      return (
        fecha.getFullYear() === ahora.getFullYear()
        && fecha.getMonth() === ahora.getMonth()
        && fecha.getDate() === ahora.getDate()
      );
    },
    esManana(fecha) {
      const manana = new Date();
      manana.setDate(manana.getDate() + 1);
      return fecha.toDateString() === manana.toDateString();
    },
    esEstaSemana(fecha) {
      const inicioSemana = new Date();
      const ahora = new Date();

      inicioSemana.setDate(ahora.getDate() - ahora.getDay());
      inicioSemana.setHours(0, 0, 0, 0);

      const finSemana = new Date(inicioSemana);
      finSemana.setDate(finSemana.getDate() + 6);
      finSemana.setHours(23, 59, 59, 999);

      return fecha >= inicioSemana && fecha <= finSemana;
    },
    esSemanaProxima(fecha) {
      const inicioProximaSemana = new Date();
      const ahora = new Date();

      inicioProximaSemana.setDate(ahora.getDate() - ahora.getDay() + 7);
      inicioProximaSemana.setHours(0, 0, 0, 0);

      const finProximaSemana = new Date(inicioProximaSemana);
      finProximaSemana.setDate(finProximaSemana.getDate() + 6);
      finProximaSemana.setHours(23, 59, 59, 999);

      return fecha >= inicioProximaSemana && fecha <= finProximaSemana;
    },
    esEsteAno(fecha) {
      const ahora = new Date();
      return fecha.getFullYear() === ahora.getFullYear();
    },
  },
  computed: {
    listadoAgrupado() {
      const grupos = {
        vencidos: [],
        hoy: [],
        manana: [],
        estaSemana: [],
        proximaSemana: [],
        esteAno: [],
        otros: [],
      };

      this.listado.forEach((item) => {
        const fecha = new Date(`${item.fecha} 23:59:59`);

        if (this.esVencido(fecha)) {
          grupos.vencidos.push(item);
        } else if (this.esHoy(fecha)) {
          grupos.hoy.push(item);
        } else if (this.esManana(fecha)) {
          grupos.manana.push(item);
        } else if (this.esEstaSemana(fecha)) {
          grupos.estaSemana.push(item);
        } else if (this.esSemanaProxima(fecha)) {
          grupos.proximaSemana.push(item);
        } else if (this.esEsteAno(fecha)) {
          grupos.esteAno.push(item);
        } else {
          grupos.otros.push(item);
        }
      });

      return grupos;
    },
  },
};
</script>

<style lang="scss">

</style>
